import { incYenOf } from '../../../lib/pricing';
const courses = {
  // page.tsx JSON-LD
  'courses.jsonld.orgName': '日本執事アカデミー',
  'courses.jsonld.parentOrgName': '一般社団法人全日本執事協会',
  'courses.jsonld.addressLocality': '東京都江東区青海2-7-4',
  'courses.backToTop': 'ページの先頭へ戻る',
  'courses.lastUpdated': '最終更新: 2026年5月1日',

  // HeroSection
  'courses.hero.homeLink': 'ホーム',
  'courses.hero.currentPage': 'コース紹介',
  'courses.hero.title': 'コース一覧・比較',
  'courses.hero.titleEn': 'COURSES',
  'courses.hero.lead': '日本執事アカデミーは、執事養成に特化した執事学校として、目的に応じて選べる3つのコースをご用意しています。執事・バトラーを目指す初心者の入門から、現役の方のスキルアップ、プロフェッショナルとして独り立ちを目指す方まで、段階的な執事養成のステップを一本の道筋としてご用意しています。\n\nまずは各コースの期間・料金・学習内容を見比べ、ご自身の目標に最も近いコースをお選びください。日本の執事学校の課程はエッセンシャル8日間48時間・アドバンス12日間72時間・マスター3ヶ月96時間から選べ、各コースの学費も一覧で比較できます。',
  'courses.hero.imgAlt': 'エッセンシャル・アドバンス・マスター3コースの実習道具を並べた情景',

  // CourseCards
  'courses.cards.label': 'THREE COURSES',
  'courses.cards.title': '3つのコース',
  'courses.cards.subtitleEn': 'Choose Your Path',
  'courses.cards.lead': '学びの段階に応じて、三つのコースをご用意しています。基礎を固めたい方、専門性を磨きたい方、プロとして独り立ちを目指す方——それぞれの目標に最短で届く設計です。期間と学費を見比べながら、ご自身の目標に合う一歩を選べます。',
  'courses.cards.recommended': '推奨',
  'courses.cards.durationLabel': '期間',
  'courses.cards.daysLabel': '日数',
  'courses.cards.hoursLabel': '時間',
  'courses.cards.priceLabel': '受講料',
  'courses.cards.priceTax': '（税込）',
  'courses.cards.targetLabel': '対象',
  'courses.cards.goalLabel': '得られること',
  'courses.cards.certLabel': '認定資格',
  'courses.cards.viewDetail': '詳細を見る',

  // CourseCards card content (index-based)
  'courses.cards.0.name': 'エッセンシャルコース',
  'courses.cards.0.duration': '1ヶ月',
  'courses.cards.0.days': '8日間',
  'courses.cards.0.hours': '48時間',
  'courses.cards.0.target': '初心者・キャリアチェンジ希望者',
  'courses.cards.0.description': '執事の基本所作と接遇の型を集中的に学ぶ入門コース。テーブルマナーからティーサービスまで、基礎を確実に固めます。',
  'courses.cards.0.certification': '認定アソシエイトバトラー',
  'courses.cards.1.name': 'アドバンスコース',
  'courses.cards.1.duration': '2ヶ月',
  'courses.cards.1.days': '12日間',
  'courses.cards.1.hours': '72時間',
  'courses.cards.1.target': '基礎知識がある方・スキルアップ希望者',
  'courses.cards.1.description': 'エッセンシャルの内容を含んだ上で、ワインサービスやイベント運営など、より高度な接遇技術まで習得する中級コース。未経験からの直接受講も可能で、本物のサービスを体験する特別実習も含みます。',
  'courses.cards.1.certification': '認定プロフェッショナルバトラー',
  'courses.cards.1.inclusionBadge': 'エッセンシャルの全内容を含みます',
  'courses.cards.1.progressionShort': '1ヶ月目：基礎(エッセンシャル内容) → 2ヶ月目：発展(ワイン・イベント・国際マナー等)',
  'courses.cards.2.name': 'マスターコース',
  'courses.cards.2.duration': '3ヶ月',
  'courses.cards.2.days': '16日間',
  'courses.cards.2.hours': '96時間',
  'courses.cards.2.target': 'プロ志望者・管理職を目指す方',
  'courses.cards.2.description': 'エッセンシャル・アドバンスの内容を含んだ上で、管理・危機対応・国際プロトコルまでを網羅する最上級コース。未経験からの直接受講も可能で、修了時には卒業ディナー実技試験を実施します。',
  'courses.cards.2.certification': '認定マスターバトラー',
  'courses.cards.2.inclusionBadge': 'エッセンシャル・アドバンスの全内容を含みます',
  'courses.cards.2.progressionShort': '1ヶ月目：エッセンシャル → 2ヶ月目：アドバンス → 3ヶ月目：マスター専門(管理・危機対応等)',

  // CourseSelector items (index-based)
  'courses.selector.0.title': '初めての方はエッセンシャル',
  'courses.selector.0.description': '執事の基礎を一から学びたい方、サービス業へのキャリアチェンジを考えている方に最適です。基本所作から丁寧に積み上げ、確かな土台を築きます。',
  'courses.selector.1.title': '経験者はアドバンス',
  'courses.selector.1.description': 'エッセンシャルの内容を含むため、未経験の方も直接受講できます。接客・サービスのご経験をお持ちの方、エッセンシャル修了からさらに専門性を高めたい方にも。ワインやイベント運営の高度な技能を身につけます。',
  'courses.selector.2.title': 'プロ・管理職志望はマスター',
  'courses.selector.2.description': 'エッセンシャル・アドバンスの内容を含むため、未経験の方も直接受講できます。執事としての独立・就業や、ホテル・レジデンスの管理職を目指す方に。家政管理や危機対応まで、プロフェッショナルとしての全領域を修めます。',

  // ComparisonTable
  'courses.comparison.label': 'COMPARISON',
  'courses.comparison.title': 'どのコースを選べばいい？',
  'courses.comparison.subtitleEn': 'Compare All Courses',
  'courses.comparison.lead': '期間や料金だけでなく、到達目標や学ぶ内容まで一覧で見比べていただけます。ご自身の目的に最も近いコースをお選びください。',
  'courses.comparison.colEssential': 'エッセンシャル',
  'courses.comparison.colAdvanced': 'アドバンス',
  'courses.comparison.colMaster': 'マスター',
  'courses.comparison.note': '※認定資格は一般社団法人全日本執事協会が独自に認定する民間資格です',
  'courses.comparison.inclusionNote': 'アドバンスはエッセンシャルの全内容を、マスターはエッセンシャル・アドバンスの全内容を含みます。どのコースも単体で完結しているため、目的に応じて1コースをお選びいただくだけで受講できます。',

  // CourseSelector
  'courses.selector.label': 'HOW TO CHOOSE',
  'courses.selector.title': 'コースの選び方',
  'courses.selector.subtitleEn': 'Find Your Best Fit',
  'courses.selector.lead': 'どのコースが合うか迷われたら、目的から逆算するのがおすすめです。初めての方、経験を活かしたい方、管理職を目指す方で、適したコースは変わります。',
  'courses.selector.viewDetail': '詳細を見る',
  'courses.selector.consultationNote': 'どのコースが最適か迷われる方は、',
  'courses.selector.consultationLink': '個別相談（無料・オンライン可）',
  'courses.selector.consultationSuffix': 'にてご提案いたします。',

  // TransferDiscount
  'courses.transfer.title': '編入優遇制度',
  'courses.transfer.lead': '段階的に学ぶほどお得になる編入優遇をご用意しています。基礎を固めてから上のコースへ進むことで、より深い学びを無理なく実現いただけます。',
  'courses.transfer.essentialLabel': 'エッセンシャル修了 → アドバンス',
  'courses.transfer.essentialAmount': '80,000円',
  'courses.transfer.essentialSuffix': ' 減額',
  'courses.transfer.advancedLabel': 'アドバンス修了 → マスター',
  'courses.transfer.advancedAmount': '180,000円',
  'courses.transfer.advancedSuffix': ' 減額',
  'courses.transfer.detailLink': '料金詳細を見る',

  // CommonInfo
  'courses.commonInfo.label': 'COMMON FEATURES',
  'courses.commonInfo.title': '全コース共通事項',
  'courses.commonInfo.subtitleEn': 'What All Courses Share',
  'courses.commonInfo.item1': 'すべての授業を土日に開催しています。お仕事を続けながら受講いただけます。',
  'courses.commonInfo.item2': '1日6時間（90分×4コマ）の集中カリキュラム。密度の高い学びを提供します。',
  'courses.commonInfo.item3': '完全少人数制（定員6名）。講師が一人ひとりの所作を細部まで確認します。',
  'courses.commonInfo.item4': 'お支払いは銀行振込による一括払いのみです。分割払い・クレジットカードはご利用いただけません。',

  // CTASection
  'courses.cta.label': 'GET STARTED',
  'courses.cta.title': 'まずはお気軽にどうぞ',
  'courses.cta.lead': '資料請求・個別相談は無料です。どのコースが最適か迷われたら、経験豊富なスタッフがあなたの目標に合わせてご提案いたします。',
  'courses.cta.note': '※ご相談はオンラインでも承ります',
  'courses.cta.brochure': '資料請求はこちら（無料）',
  'courses.cta.consultation': '個別相談を予約する',
  'courses.cta.seminar': '1日体験する（体験講座）',
  'courses.cta.corporateNote': '企業・団体でのご検討は',
  'courses.cta.corporateLink': '法人研修（出張型）へ',

  // FAQSection
  'courses.faq.label': 'FAQ',
  'courses.faq.title': 'よくあるご質問',
  'courses.faq.subtitleEn': 'Frequently Asked Questions',
  'courses.faq.moreQuestions': 'その他のご質問はフォームよりお寄せください',
  'courses.faq.0.question': '初心者はどのコースですか？',
  'courses.faq.0.answer': '初めての方にはエッセンシャルコース（1ヶ月・48時間）をお勧めします。基礎の所作から体系的に学べます。',
  'courses.faq.1.question': '途中のコースから始められますか？',
  'courses.faq.1.answer': 'はい。アドバンスはエッセンシャルの内容を、マスターはエッセンシャル・アドバンスの内容を含むため、未経験からでも直接始められます。最適な選択は個別相談でもご提案します。',
  'courses.faq.2.question': '支払い方法は？',
  'courses.faq.2.answer': '銀行振込による一括払いのみです。分割払い・クレジットカードはご利用いただけません。',
  'courses.faq.3.question': '3つのコースの違いは何ですか？',
  'courses.faq.3.answer': 'エッセンシャル（1ヶ月・48時間）は基礎の型を固める入門課程、アドバンス（2ヶ月・72時間）はエッセンシャルの内容を含めてワインやイベント運営など高度な接遇まで学ぶ中級課程、マスター（3ヶ月・96時間）はエッセンシャル・アドバンスの内容を含めて家政管理・危機対応・国際プロトコルまで修める最上級課程です。どのコースも単体で完結しているため、目的に応じて1コースをお選びいただくだけで受講できます。',
  'courses.faq.4.question': '定員は何名ですか？',
  'courses.faq.4.answer': '各コース最大6名の完全少人数制です。最少催行人数は3名で、ご受講は先着順に承ります。',
  'courses.faq.5.question': '働きながらでも通えますか？',
  'courses.faq.5.answer': '全コース土日開催（1日6時間・90分×4コマ）で、平日にお勤めの方でも計画的に通学いただけます。予習・復習用のオンデマンド動画も併用でき、対面授業では実技に集中できます。',
  'courses.faq.6.question': 'コースを段階的に進めると割引はありますか？',
  'courses.faq.6.answer': '編入優遇があります。エッセンシャル修了後にアドバンスへ進む場合はアドバンス受講料から80,000円（税込）、アドバンス修了後にマスターへ進む場合はマスター受講料から180,000円（税込）を減額します。',

  // RelatedPages
  'courses.related.label': 'LEARN MORE',
  'courses.related.title': '関連ページ',
  'courses.related.subtitleEn': 'Explore Further',
  'courses.related.viewDetail': '詳しく見る',
  'courses.related.0.title': 'エッセンシャルコース',
  'courses.related.0.description': '基礎から始める入門課程',
  'courses.related.1.title': 'アドバンスコース',
  'courses.related.1.description': '専門技能を磨く中級課程',
  'courses.related.2.title': 'マスターコース',
  'courses.related.2.description': '管理・危機対応まで修める最上級課程',
  'courses.related.3.title': '年間スケジュール',
  'courses.related.3.description': '開校時期と授業日程',
  'courses.related.4.title': 'コース別料金詳細',
  'courses.related.4.description': 'コースごとの料金内訳',
  'courses.related.5.title': 'カリキュラム',
  'courses.related.5.description': '各コースで学ぶ内容の全体像',

  // comparisonRows: row labels
  'courses.row.duration': '期間',
  'courses.row.days': '総日数',
  'courses.row.hours': '総時間',
  'courses.row.price': '受講料（税込）',
  'courses.row.schedule': '開校時期',
  'courses.row.target': '対象者',
  'courses.row.goal': '到達目標',
  'courses.row.content': '主な学習内容',
  'courses.row.cert': '認定資格',
  'courses.row.transfer': '編入優遇',

  // comparisonRows: essential column values
  'courses.row.essential.duration': '1ヶ月',
  'courses.row.essential.days': '8日間',
  'courses.row.essential.hours': '48時間',
  'courses.row.essential.price': `${incYenOf('ac-essential')}円`,
  'courses.row.essential.schedule': '7月・1月',
  'courses.row.essential.target': '初心者・キャリアチェンジ希望者',
  'courses.row.essential.goal': '基本的な所作と接遇の型を身につけ、単独で日常的なサービスができる',
  'courses.row.essential.content': '基本マナー・家事管理・テーブルセッティング・紅茶とコーヒー・衣類ケア・コミュニケーション',
  'courses.row.essential.cert': '認定アソシエイトバトラー',
  'courses.row.essential.transfer': '—',

  // comparisonRows: advanced column values
  'courses.row.advanced.duration': '2ヶ月',
  'courses.row.advanced.days': '12日間',
  'courses.row.advanced.hours': '72時間',
  'courses.row.advanced.price': `${incYenOf('ac-advanced')}円`,
  'courses.row.advanced.schedule': '5〜6月・11〜12月',
  'courses.row.advanced.target': '基礎知識がある方・スキルアップ希望者（未経験からの直接受講も可）',
  'courses.row.advanced.goal': 'エッセンシャルの内容を含めた高度なサービス技術とワイン知識を備え、複数ゲストへの対応ができる',
  'courses.row.advanced.content': 'エッセンシャルの全内容＋高度サービス技術・ワインとスピリッツ・イベント計画運営・国際マナー・高級衣類ケア',
  'courses.row.advanced.cert': '認定プロフェッショナルバトラー',
  'courses.row.advanced.transfer': 'E修了→▲80,000円',

  // comparisonRows: master column values
  'courses.row.master.duration': '3ヶ月',
  'courses.row.master.days': '16日間',
  'courses.row.master.hours': '96時間',
  'courses.row.master.price': `${incYenOf('ac-master')}円`,
  'courses.row.master.schedule': '2〜4月・9〜11月',
  'courses.row.master.target': 'プロ志望者・管理職を目指す方（未経験からの直接受講も可）',
  'courses.row.master.goal': 'エッセンシャル・アドバンスの内容を含めた管理・危機対応・国際儀礼を修め、執事長としてチームを統率できる',
  'courses.row.master.content': 'エッセンシャル・アドバンスの全内容＋家政管理・危機対応とセキュリティ・国際プロトコル・VIP対応・リーダーシップ',
  'courses.row.master.cert': '認定マスターバトラー',
  'courses.row.master.transfer': 'A修了→▲180,000円',
};

export default courses;
